/* ADD Knowledge categories */
export const GET_CUSTOMER = "GET_CUSTOMER"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_CUSTOMER_CLEAN = "GET_CUSTOMER_CLEAN"
export const GET_CUSTOMER_ERROR = "GET_CUSTOMER_ERROR"
